import { useQuery, useQueryClient } from "@tanstack/react-query";
import { DESIGN_STORE } from "../../constants/QueryKeys";
import LibraryService from "../../service/LibraryService";

const defaults = {
  enabled: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchOnMount: false,
  retry: false,
  staleTime: Infinity,
};

export default function useDesignImport(settings = {}) {
  const queryClient = useQueryClient();
  const data = useQuery({
    queryKey: [DESIGN_STORE],
    queryFn: LibraryService.loadDesignExport,
    ...defaults,
    ...settings,
  });
  const getDesign = (exportKey) => {
    queryClient.fetchQuery({
      queryKey: [DESIGN_STORE],
      queryFn: () => LibraryService.loadDesignExport(exportKey),
    });
  };
  const clearDesign = () => {
    queryClient.removeQueries({ queryKey: [DESIGN_STORE] });
  };
  return { ...data, getDesign, clearDesign };
}
